export class StartPayError extends Error {
  code: string;
  details?: unknown;

  constructor(message: string, code = "SDK_ERROR", details?: unknown) {
    super(message);
    this.name = "StartPayError";
    this.code = code;
    this.details = details;
  }
}

export const toStartPayError = (error: unknown, fallback = "Something went wrong while starting payment") => {
  if (error instanceof StartPayError) return error;
  if (error instanceof Error) return new StartPayError(error.message || fallback, "SDK_ERROR", error);
  return new StartPayError(fallback, "SDK_ERROR", error);
};
